
document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('.js-product-meta-description');
  const descriptionBtn = document.querySelector('.js-product-meta-description-btn');
  
  if (description && descriptionBtn) {
    const firstChild = description.children[0];
    if (firstChild) {
      const collapsedHeight = firstChild.offsetHeight;
      description.style.setProperty('--collapsed-height', `${collapsedHeight}px`);
    }
    
    descriptionBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      description.classList.add('is-expanded');
      descriptionBtn.classList.add('hide-button');
    });
  }
});
